import { NavLink } from 'react-router-dom'
import Translation from '../Translation/cont/Translation'

const SidebarMenuLink = ({linkID, path, name, transId, itemClassName}) => {
    return (
        <li className={linkID}>
            <NavLink to={path} exact activeClassName="active">
                <span className={itemClassName}><Translation id={transId}>{name}</Translation></span>
            </NavLink>
        </li>
    )
}

export default SidebarMenuLink